// Single source of truth for the "Solutions" mega-menu shown on the public
// nav and the landing-page nav. Both navbars import this list so the
// dropdown stays consistent if niches are added/renamed/reordered.
import { FaUserTie, FaGraduationCap, FaBriefcase, FaHeartbeat, FaPassport } from 'react-icons/fa';

export const SOLUTIONS = [
  {
    to: '/for/coaches',
    label: 'Coaches',
    blurb: 'Sell coaching packages in one booking',
    icon: FaUserTie,
    iconBg: 'from-violet-500 to-indigo-600',
  },
  {
    to: '/for/tutors',
    label: 'Tutors & Teachers',
    blurb: 'Schedule lessons, sell term packages, INR pricing',
    icon: FaGraduationCap,
    iconBg: 'from-emerald-500 to-teal-600',
  },
  {
    to: '/for/consultants',
    label: 'Consultants',
    blurb: 'Premium scheduling with AI + webhooks',
    icon: FaBriefcase,
    iconBg: 'from-indigo-500 to-blue-600',
  },
  {
    to: '/for/allied-health',
    label: 'Allied Health',
    blurb: 'Private notes, AU-compliant, no bloat',
    icon: FaHeartbeat,
    iconBg: 'from-teal-500 to-cyan-600',
  },
  {
    to: '/for/migration-agents',
    label: 'Migration Agents',
    blurb: 'Visa consultations, multi-timezone clients',
    icon: FaPassport,
    iconBg: 'from-amber-500 to-orange-600',
  },
];
